import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import SmsIcon from '@material-ui/icons/Sms'
import TwitterIcon from '@material-ui/icons/Twitter'
import FacebookIcon from '@material-ui/icons/Facebook'
import SvgIcon from '@material-ui/core/SvgIcon'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import messengerPng from '../../../../assets/images/messenger.png'
import mustache from 'mustache'

const services = ['whatsapp', 'messenger', 'twitter', 'facebook', 'sms']

const colours = {
  whatsapp: '#2fb72e',
  messenger: '#0060c4',
  twitter: '#00a3f9',
  facebook: '#4267B2',
  sms: '#fe8f00',
}

const useStyles = makeStyles((theme) => ({
  root: (props) => ({ backgroundColor: colours[props.service], color: 'white' }),
  label: {
    justifyContent: 'left',
  },
  endIcon: {
    flex: 1,
    justifyContent: 'flex-end',
    marginRight: -14,
  },
}))

const getIcon = (service) => {
  const Messenger = () => (
    <div>
      <img
        src={messengerPng}
        alt="messenger icon"
        style={{ marginBottom: -4, height: 30, width: 30 }}
      />
    </div>
  )

  switch (service) {
    case 'whatsapp':
      return <WhatsAppIcon fontSize="large" />
    case 'messenger':
      return <SvgIcon component={Messenger} />
    case 'twitter':
      return <TwitterIcon />
    case 'facebook':
      return <FacebookIcon />
    case 'sms':
      return <SmsIcon />
  }
}

const parseShareTemplate = (template, constituency) => {
  const vars = {
    constituency_id: constituency?.id,
    constituency_name: constituency?.name,
    mp_name: constituency?.mp_name,
    num_children: constituency?.poverty_stats['number_201920'],
  }
  try {
    return mustache.render(template, vars)
  } catch {
    return false
  }
}

const buildShareUrl = ({
  service,
  constituency,
  template,
  isMobile,
  signup,
  fallback,
  useFallback,
}) => {
  let baseUrl = constituency?.id ? `${window.location.origin}/c/${constituency.id}` : `${window.location.origin}/`
  if (signup?.public_token) baseUrl += `?public_token=${signup.public_token}`
  const shareText = useFallback
    ? fallback
    : parseShareTemplate(template, constituency) || fallback

  switch (service) {
    case 'whatsapp':
      return `${
        isMobile ? 'whatsapp://' : 'https://wa.me/'
      }send?text=${encodeURIComponent(shareText + ' | ' + baseUrl)}`
    case 'messenger':
      return `fb-messenger://share?link=${baseUrl}`
    case 'twitter':
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        shareText + ' | ' + baseUrl
      )}`
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(baseUrl)}`
    case 'sms':
      return `sms:?body=${encodeURIComponent(shareText + ' | ' + baseUrl)}`
  }
}

const ShareButton = ({ service, url, fragments }) => {
  const classes = useStyles({ service })
  const [cookies] = useCookies()
  const admin = cookies['neu_nclb_admin']

  return (
    <div>
      <Button
        variant="contained"
        disableElevation
        fullWidth
        {...{ classes }}
        startIcon={getIcon(service)}
        endIcon={<ChevronRightIcon />}
        href={url}
        target="_blank"
      >
        Share on {service}
      </Button>
      {admin && service !== 'messenger' && (
        <Button
          size="small"
          variant="contained"
          color="secondary"
          href={`/admin/fragment/${fragments['share_text_' + service]?.id}/edit`}
        >
          Edit share text
        </Button>
      )}
    </div>
  )
}

const ShareButtons = ({ constituency, signup, generic }) => {
  const isMobile = navigator.userAgent.includes('Mobi')
  const fragments = useSelector((state) => state.local.fragments)

  if (!fragments) return null

  return (
    <Grid container spacing={3}>
      {services.map((service) =>
        !isMobile && ['sms', 'messenger'].includes(service) ? null : (
          <Grid item xs={12} sm={6} key={service}>
            <ShareButton
              {...{
                service,
                fragments,
                url: buildShareUrl({
                  service,
                  constituency,
                  template: fragments['share_text_' + service]?.content,
                  fallback: fragments['share_text_fallback']?.content,
                  isMobile,
                  signup,
                  useFallback: generic,
                }),
              }}
            />
          </Grid>
        )
      )}
    </Grid>
  )
}

export default ShareButtons
